module.exports = __webpack_public_path__ + "assets/b787227fd703c5281b480166845463b7.png";